// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CheckThinIconSignature {
  Element: SVGSVGElement;
}

export const CheckThinIcon: TOC<CheckThinIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M10.6 19.4L3 13.8L4.2 12.2L10.2 16.6L19 5L20.6 6.2L10.6 19.4Z"/>
</svg>
</template>;